module.exports = __webpack_public_path__ + "static/media/81mmInox.d3ba2950.png";